// Poll-verify UX — shared timing constants and UI phase strings.

export const VERIFY_POLL_INTERVAL_MS = 3000;
export const VERIFY_INITIAL_DELAY_MS = 2000;
export const VERIFY_MAX_ATTEMPTS = 40;

// After this many ms with no POST response, start a parallel GET verify loop.
export const PARALLEL_VERIFY_START_MS = 20000;

export const SAVE_PHASE_STRINGS = {
  saving:
    'Saving your changes…\nThis request might take a little while. Please keep this page open.',
  verifyingSubline:
    'Large groups can take longer — please keep this page open.',
  verifying:
    "Confirming your save…\nWe're checking that your changes were applied.",
  unknown:
    "We couldn't confirm whether your save completed.\nPlease check the Groups (or Roles) list before submitting again.",
};
